import { useEffect, useState } from 'react';
import __useMedia from 'react-use/lib/useMedia';

import { ViewportSize } from '../../../utils';

const useMedia = () => {
    const query = (min: number, max: number) => `(min-width: ${min}px) and (max-width: ${max - 1}px)`;
    const [state, setState] = useState<ViewportSize>(ViewportSize.PHONE_S);
    const isPhoneM = __useMedia(query(ViewportSize.PHONE_M, ViewportSize.PHONE_L));
    const isPhoneL = __useMedia(query(ViewportSize.PHONE_L, ViewportSize.TABLET));
    const isTablet = __useMedia(query(ViewportSize.TABLET, ViewportSize.DESKTOP_S));
    const isDesktopS = __useMedia(query(ViewportSize.DESKTOP_S, ViewportSize.DESKTOP_M));
    const isDesktopM = __useMedia(query(ViewportSize.DESKTOP_M, ViewportSize.DESKTOP_L));
    const isDesktopMMax = __useMedia(query(ViewportSize.DESKTOP_M_MAX, ViewportSize.DESKTOP_L));
    const isDesktopL = __useMedia(`(min-width: ${ViewportSize.DESKTOP_L}px)`);

    useEffect(() => {
        switch (true) {
            case isDesktopL:
                setState(ViewportSize.DESKTOP_L);
                return;

            case isDesktopMMax:
                setState(ViewportSize.DESKTOP_M_MAX);
                return;

            case isDesktopM:
                setState(ViewportSize.DESKTOP_M);
                return;

            case isDesktopS:
                setState(ViewportSize.DESKTOP_S);
                return;

            case isTablet:
                setState(ViewportSize.TABLET);
                return;

            case isPhoneL:
                setState(ViewportSize.PHONE_L);
                return;

            case isPhoneM:
                setState(ViewportSize.PHONE_M);
                return;

            default:
                setState(ViewportSize.PHONE_S);
        }
    }, [isPhoneM, isPhoneL, isTablet, isDesktopS, isDesktopM, isDesktopMMax, isDesktopL]);

    return state;
};

export default useMedia;
